import { Box } from '@mui/material';
import { Props as LegendProps } from 'recharts/types/component/Legend';

import { Typography } from '@occc/ui-design-system';

import { DailyNewLegendIcon } from './icons/daily-new-legend.icon';
import { TotalNewLegendIcon } from './icons/total-new-legend.icon';

// By some reason the recharts library has a bad type definition so in some cases we have to use 'any'
export const CustomLegend = (props: LegendProps) => {
  const { payload = [] } = props;

  return (
    <Box display='flex' justifyContent='center' my={1}>
      {payload
        .map((entry: any, index) => (
          <Box
            key={`item-${index}`}
            display='flex'
            justifyContent='flex-start'
            alignItems='center'
            mr={2}
          >
            {entry.dataKey === 'dailyNew' ? <DailyNewLegendIcon /> : <TotalNewLegendIcon />}
            <Typography variant='body2' ml={0.5} color='textSecondary'>
              {entry.value}
            </Typography>
          </Box>
        ))
        .reverse()}
    </Box>
  );
};
